export default "__VITE_ASSET__Cv7$M0Ja__"